function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true, composed: true });
    this.inputEvent = new Event('input', { bubbles: true, composed: true });
    this._cartQtySyncTimer = null;
    this._dispatchingButtonEvents = false;

    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
    this.input.addEventListener('input', this.onCartQuantityInput.bind(this));
    this.input.addEventListener('change', this.onCartQuantityChange.bind(this));
  }

  getClampedQuantity(rawQuantity) {
    const parsedQuantity = parseInt(rawQuantity, 10);
    const minQuantity = parseInt(this.input.getAttribute('min'), 10);
    const maxQuantity = parseInt(this.input.getAttribute('max'), 10);

    const safeMin = Number.isFinite(minQuantity) ? minQuantity : 0;
    let nextQuantity = Number.isFinite(parsedQuantity) ? parsedQuantity : safeMin;
    if (nextQuantity < safeMin) {
      nextQuantity = safeMin;
    }
    if (Number.isFinite(maxQuantity) && nextQuantity > maxQuantity) {
      nextQuantity = maxQuantity;
    }

    return nextQuantity;
  }

  setInputQuantity(quantity) {
    this.input.value = String(quantity);
  }

  syncCartFromInput() {
    const cartItemsRoot = this.closest('cart-items');
    if (!cartItemsRoot || typeof cartItemsRoot.updateQuantity !== 'function') {
      return;
    }
    const clampedQuantity = this.getClampedQuantity(this.input.value);
    this.setInputQuantity(clampedQuantity);

    if (cartItemsRoot.isUpdating) {
      this.setInputQuantity(this.input.dataset.renderedQuantity);
      cartItemsRoot.pendingInputRejected = true;
      return;
    }

    cartItemsRoot.updateQuantity({
      line: this.input.dataset.index,
      quantity: clampedQuantity,
      id: this.input.dataset.id,
      variantId: this.input.dataset.variantId,
      groupId: this.input.dataset.groupId,
    });
  }

  onCartQuantityInput() {
    const cartItemsRoot = this.closest('cart-items');
    if (this._dispatchingButtonEvents || !cartItemsRoot) {
      return;
    }
    if (cartItemsRoot.isUpdating) {
      this.setInputQuantity(this.input.dataset.renderedQuantity);
      cartItemsRoot.pendingInputRejected = true;
      return;
    }
    window.clearTimeout(this._cartQtySyncTimer);
    this._cartQtySyncTimer = window.setTimeout(() => {
      this._cartQtySyncTimer = null;
      this.syncCartFromInput();
    }, 350);
  }

  onCartQuantityChange() {
    const cartItemsRoot = this.closest('cart-items');
    if (this._dispatchingButtonEvents || !cartItemsRoot) {
      return;
    }
    if (cartItemsRoot.isUpdating) {
      this.setInputQuantity(this.input.dataset.renderedQuantity);
      cartItemsRoot.pendingInputRejected = true;
      return;
    }
    window.clearTimeout(this._cartQtySyncTimer);
    this._cartQtySyncTimer = null;
    this.syncCartFromInput();
  }

  onButtonClick(event) {
    event.preventDefault();
    const cartItemsRoot = this.closest('cart-items');
    if (cartItemsRoot?.isUpdating) {
      return;
    }
    window.clearTimeout(this._cartQtySyncTimer);
    this._cartQtySyncTimer = null;
    const previousValue = this.getClampedQuantity(this.input.value);
    const button = event.currentTarget;
    const isPlus = button.getAttribute('name') === 'plus';

    let nextValue;
    this._dispatchingButtonEvents = true;
    try {
      isPlus ? this.input.stepUp() : this.input.stepDown();
      nextValue = this.getClampedQuantity(this.input.value);
      this.setInputQuantity(nextValue);
      if (previousValue !== nextValue) {
        this.input.dispatchEvent(this.inputEvent);
        this.input.dispatchEvent(this.changeEvent);
      }
    } finally {
      this._dispatchingButtonEvents = false;
    }
    if (previousValue !== nextValue && cartItemsRoot) {
      this.syncCartFromInput();
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();


    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  get mainDetailsToggle() {
    return this.querySelector('details');
  }

  get summaryElements() {
    return this.querySelectorAll('summary');
  }

  connectedCallback() {
    this.addAccessibilityAttributes(this.summaryElements);
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.init();
  }

  init() {
    this.onloadColourAvailability();
    this.onloadSizeAvailability();
    this.onColorChange();
    this.toggleScrolledPastFormButton();

    window.addEventListener(
      'load',
      function () {
        this.renderSliderColorImages();
      }.bind(this)
    );
  }

  connectedCallback() {
    setTimeout(() => {
      this.updateOptions();
      this.updateMasterId();
      this.handleAddBtnPrice();
    }, 2000);
  }

  onVariantChange() {
    this.renderSliderColorImages();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      if (this.hasCompleteOptionSelection()) {
        this.setUnavailable();
      } else {
        this.getPriceContainers(this.getProductScope()).forEach(price => price.classList.remove('visibility-hidden'));
      }
      this.handleSizeSelectedAddButton();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateMainPrice();
      this.renderProductInfo();
      this.updateVariantName();
      this.handleSizeSelectedAddButton();
      this.handleAddBtnPrice();
      this.updateOptionLabels();
    }
  }

  onloadColourAvailability() {
    const variantOptions = this.getVariantData();
    const primaryOptions = new Set(variantOptions.map(option => option.option1));
    const productColourSelectedVariants = this.querySelectorAll('.product-form__input.product-color-swatches input');
    productColourSelectedVariants.forEach(input => {
      const colorValue = input.getAttribute('value');
      if (Array.from(primaryOptions).includes(colorValue)) {
        let options = variantOptions.filter(option => option.option1 === colorValue);
        let optionAvailability = options.every(option => option.available === false);
        if (optionAvailability) {
          input.classList.add('disabled');
        }
      }
    });
  }

  onloadSizeAvailability() {
    const variantOptions = this.getVariantData();
    const primaryOptions = new Set(variantOptions.map(option => option.option1));
    const productSizeSelectedVariants = this.querySelectorAll('.product-form__input.product-size-selector input');
    const productColourSelectedVariant = document.querySelector('.product-form__input.product-color-swatches input:checked');
    productSizeSelectedVariants.forEach(input => {
      const sizeValue = input.getAttribute('value');
      const colorValue = productColourSelectedVariant.getAttribute('value');
      const selectedVariantLabel = this.querySelector('.product-form__input.product-color-swatches .form__label span');
      if (selectedVariantLabel) {
        if (colorValue) {
          selectedVariantLabel.textContent = colorValue;
        }
      }
      if (Array.from(primaryOptions).includes(colorValue)) {
        let options = variantOptions.filter(option => option.option1 === colorValue);
        let soldoutSizeVariants = options.filter(option => option.available === false);
        input.classList.contains('disabled') ? input.classList.remove('disabled') : null;
        soldoutSizeVariants.forEach(variant => {
          if (variant.option2 === sizeValue) {
            input.classList.add('disabled');
          }
        });
      }
    });
  }

  onColorChange() {
    const productColourSelectedVariant = this.querySelectorAll('.product-form__input.product-color-swatches input');
    if (productColourSelectedVariant) {
      productColourSelectedVariant.forEach(input => {
        input.addEventListener('change', this.onloadSizeAvailability.bind(this));
      });
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value);
  }

  updateMasterId() {
    const variants = this.getVariantData();
    this.currentVariant = variants.find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (variants.length === 1) {
      this.currentVariant = variants[0];
    }
  }

  hasCompleteOptionSelection() {
    return Array.isArray(this.options) && this.options.every(option => option !== undefined && option !== '');
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
    const parent = newMedia.parentElement;
    if (parent.firstChild === newMedia) return;
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
    });
  }

  updateURL() {
    if (window.location.href.includes('/products')) {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateVariantName() {
    if (!this.currentVariant.title) return;
    const selectedVariantLabel = document.querySelector('.product-form__input.product-color-swatches .form__label span');
    if (selectedVariantLabel) {
      if (this.currentVariant.title.includes('/')) {
        selectedVariantLabel.textContent = this.currentVariant.title.split('/')[0];
      } else {
        selectedVariantLabel.textContent = this.currentVariant.title;
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    if (!this.dataset.section) return;
    const variantId = this.currentVariant.id;
    const cacheBuster = new Date().getTime();
    return fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}&_=${cacheBuster}`)
      .then(response => response.text())
      .then(responseText => {
        if (!this.isConnected || !this.currentVariant || this.currentVariant.id !== variantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinations = this.getPriceContainers(this.getProductScope());
        const sources = this.getPriceContainers(html);

        destinations.forEach((destination, index) => {
          const position = destination.dataset.pricePosition;
          const source = sources.find((item) => item.dataset.pricePosition === position) || sources[index] || sources[0];

          if (source) destination.innerHTML = source.innerHTML;
          destination.classList.remove('visibility-hidden');
        });

        this.applyAutoDiscount();
        this.handleAddBtnPrice();
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(() => {});
  }

  getPriceContainers(root = document) {
    const containers = Array.from(root.querySelectorAll(`[data-price-container="${this.dataset.section}"]`));
    const fallback = root.querySelector(`#price-${this.dataset.section}`);

    if (fallback && !containers.includes(fallback)) containers.push(fallback);
    return containers;
  }

  getMoneyFormat(priceRoot) {
    const useCurrencyCode = priceRoot && priceRoot.dataset.currencyCodeEnabled === 'true';
    return useCurrencyCode && window['theme'].moneyWithCurrencyFormat
      ? window['theme'].moneyWithCurrencyFormat
      : window['theme'].moneyFormat;
  }

  getProductScope() {
    return this.closest('.product-quick-view') || this.closest('section') || document;
  }

  applyAutoDiscount() {
    if (window.SR && window.SR.autoDiscount) {
      window.SR.autoDiscount.apply(this.getProductScope());
    }
  }

  formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "")
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split(".")
        , dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
        , cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break
    }
    return formatString.replace(placeholderRegex, value)
  }

  handleAddBtnPrice() {
    if (!this.currentVariant || !this.currentVariant.title) return;
    const parentEl = this.closest('.product-quick-view') || document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (!parentEl) return;

    const priceRoot = parentEl.querySelector('.price');
    const isAutoDiscount = priceRoot && priceRoot.dataset.srAutoDiscountApplied === 'true';
    let price = this.formatMoney(this.currentVariant.price, this.getMoneyFormat(priceRoot));
    if (isAutoDiscount) {
      price = parentEl.querySelector('.price-item--sale').textContent.trim();
    }

    const addButtonPrice = parentEl.querySelector('[name="add"] .btn-price');
    if (price && addButtonPrice && addButtonPrice.textContent !== price) {
      addButtonPrice.textContent = price;
    }
  }

  updateMainPrice() {
    if (!this.currentVariant || !this.dataset.section) return;

    const priceContainers = this.getPriceContainers(this.getProductScope());
    const firstPriceRoot = priceContainers[0] ? priceContainers[0].querySelector('.price') : null;
    const moneyFormat = this.getMoneyFormat(firstPriceRoot);
    const formattedPrice = window.Shopify.formatMoney(this.currentVariant.price, moneyFormat);
    const formattedComparePrice = this.currentVariant.compare_at_price ? window.Shopify.formatMoney(this.currentVariant.compare_at_price, moneyFormat) : null;
    const hasNativeSale = formattedComparePrice && this.currentVariant.compare_at_price > this.currentVariant.price;

    priceContainers.forEach(priceContainer => {
      const priceRoot = priceContainer.querySelector('.price');
      if (!priceRoot) return;

      const regularPriceEl = priceRoot.querySelector('.price__regular .price-item--regular');
      const salePriceEl = priceRoot.querySelector('.price-item--sale');
      const comparePriceEl = priceRoot.querySelector('.price__sale s.price-item--regular');

      if (regularPriceEl) regularPriceEl.textContent = formattedPrice;
      if (salePriceEl) salePriceEl.textContent = formattedPrice;
      if (comparePriceEl) comparePriceEl.textContent = formattedComparePrice || '';

      priceRoot.dataset.priceMin = this.currentVariant.price;
      priceRoot.dataset.priceMax = this.currentVariant.price;
      priceRoot.dataset.priceVaries = 'false';
      priceRoot.dataset.compareAtPriceMin = this.currentVariant.compare_at_price || 0;
      priceRoot.dataset.compareAtPriceMax = this.currentVariant.compare_at_price || 0;
      priceRoot.dataset.compareAtPriceVaries = 'false';
      priceRoot.dataset.nativeSale = hasNativeSale ? 'true' : 'false';
      delete priceRoot.dataset.srAutoDiscountApplied;
      delete priceRoot.dataset.srAutoDiscountPercent;
      priceRoot.classList.remove('price--range');
      priceRoot.classList.toggle('price--on-sale', Boolean(hasNativeSale));
    });

    this.applyAutoDiscount();
  }

  updateOptionLabels() {
    const selectedOptions = this.querySelectorAll('.swatch__element input:checked');
    selectedOptions.forEach(selected => {
      const selectedLabel = document.querySelector('.option-label-' + selected.name);

      if (selectedLabel) {
        selectedLabel.textContent = selected.value;
      }
    });
  }

  handleSizeSelectedAddButton() {
    const productForm = document.querySelector(`.product-form`);
    const selectSizeBtn = document.querySelector(`.select-size`);
    if (!productForm) return;
    if (!selectSizeBtn.classList.contains('size-selected')) {
      selectSizeBtn.classList.add('size-selected');
    }
    if (productForm.classList.contains('size-not-selected')) {
      productForm.classList.remove('size-not-selected');
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  toggleScrolledPastFormButton() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    const footer = document.getElementById('footer');
    if (productForm) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > productForm.offsetTop + productForm.offsetHeight && window.scrollY + 150 < footer.offsetTop - footer.offsetHeight) {
          productForm.classList.add('scrolled-past');
        } else {
          productForm.classList.remove('scrolled-past');
        }
      });
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = this.getPriceContainers(this.getProductScope())[0];
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[data-variant-data]').textContent);

    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      if (Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked)) {
        return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
      }
    });
  }

  renderSliderColorImages() {
    const color = $('.product-form__input.product-color-swatches input:checked').val().toLowerCase();
    if (color.length > 0) {
      $('.productimageslider').trigger('productColourChanged', { color: color });
      $('.mobileproductimageslider').trigger('productColourChanged', { color: color });
      $('.quickviewproductimageslider').trigger('productColourChanged', { color: color });
    } else {
      $('.productimageslider').trigger('productColoursReset');
      $('.mobileproductimageslider').trigger('productColourChanged', { color: color });
      $('.quickviewproductimageslider').trigger('productColoursReset');
    }
  }
}

customElements.define('variant-radios', VariantRadios);
